import React from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { MOVEMENT_KINDS, CONSUMABLE_TYPES, fmtDate, fmtMoney, labelOf, Pill } from "./constants";

export function MovementsList({ movements = [], showConsumable = true, showPrinter = true, onDelete, emptyText = "Aucun mouvement", compact = false }) {
    const navigate = useNavigate();
    if (movements.length === 0) return <p className="text-xs text-gray-400 py-4 text-center">{emptyText}</p>;
    return (
        <div className="divide-y divide-gray-50" data-testid="movements-list">
            {movements.map((m) => {
                const kind = MOVEMENT_KINDS[m.kind] || MOVEMENT_KINDS.adjustment;
                const delta = m.delta || 0;
                return (
                    <div key={m.id} className={`flex items-start gap-3 ${compact ? "py-1.5" : "py-2.5"}`} data-testid={`movement-${m.id}`}>
                        <div className="w-20 flex-shrink-0 text-[11px] text-gray-500 pt-0.5">{fmtDate(m.date)}</div>
                        <Pill className={kind.color}>{kind.label}</Pill>
                        <span className={`text-sm font-mono font-semibold w-10 text-right flex-shrink-0 ${delta > 0 ? "text-emerald-600" : delta < 0 ? "text-red-600" : "text-gray-500"}`} data-testid={`movement-delta-${m.id}`}>
                            {delta > 0 ? `+${delta}` : delta}
                        </span>
                        <div className="flex-1 min-w-0 text-xs text-gray-700">
                            {showConsumable && (
                                <span className="font-medium">{m.consumable_name}{m.consumable_reference ? <span className="text-gray-400 font-mono"> · {m.consumable_reference}</span> : ""}<span className="text-gray-400"> ({labelOf(CONSUMABLE_TYPES, m.consumable_type)})</span></span>
                            )}
                            {showPrinter && m.printer_name && (
                                <div className="text-[11px]">
                                    Installé sur{" "}
                                    <button className="text-teal-600 hover:underline" onClick={() => navigate(`/admin/inventory/printers/${m.printer_id}`)}>{m.printer_name}</button>
                                </div>
                            )}
                            {m.kind === "purchase" && (m.unit_price !== null && m.unit_price !== undefined || m.company_name || m.invoice_number) && (
                                <div className="text-[11px] text-gray-500">
                                    {m.unit_price !== null && m.unit_price !== undefined ? `${fmtMoney(m.unit_price)} / unité` : ""}
                                    {m.company_name ? ` · ${m.company_name}` : ""}
                                    {m.invoice_number ? ` · Facture ${m.invoice_number}` : ""}
                                </div>
                            )}
                            {m.notes && <div className="text-[11px] text-gray-500 italic">{m.notes}</div>}
                            {m.actor_name && <div className="text-[10px] text-gray-400">par {m.actor_name}</div>}
                        </div>
                        {onDelete && (
                            <button onClick={() => onDelete(m)} className="text-gray-300 hover:text-red-500 flex-shrink-0" title="Annuler ce mouvement (le stock est recalculé)" data-testid={`movement-delete-${m.id}`}>
                                <X className="w-3.5 h-3.5" />
                            </button>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
